export const scrollToSectionUtils = (sectionId, onComplete) => {
    const element = document.getElementById(sectionId);
    if (!element) {
        onComplete?.();
        return;
    }
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    onComplete?.();
};
